import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { ArrowLeft, User, Users } from 'lucide-react';
import { useAuthContext } from '../../auth/data/context/AuthContext';

const AccountSidebar: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useAuthContext();
  const isSuperAdmin = state.user?.role_name === 'Super Admin';

  return (
    <aside className="settings-sidebar">
      <div className="settings-sidebar-content">
        <div className="settings-page-header">
          <button className="settings-back-btn" onClick={() => navigate('/dashboard')} title="Back to Dashboard">
            <ArrowLeft size={20} />
          </button>
          <h1 className="settings-page-title">Account Management</h1>
        </div>
        
        <NavLink 
          to="/account/info" 
          className={({ isActive }) => `settings-nav-item ${isActive ? 'active' : ''}`}
        >
          <User size={18} />
          <span>Account Information</span>
        </NavLink>
        
        {isSuperAdmin && (
          <NavLink 
            to="/account/users" 
            className={({ isActive }) => `settings-nav-item ${isActive ? 'active' : ''}`}
          >
            <Users size={18} />
            <span>User Management</span>
          </NavLink>
        )}
      </div>
    </aside>
  );
};

export default AccountSidebar;
